import { useState } from "react";

export const useLocalStorage = (key, initialValue) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const usuario = window.usuario;
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      let item;
      if(usuario){
        item = window.localStorage.getItem(`${key}-${usuario.CompaniaId}`);
      }else{
        item = window.localStorage.getItem(`${key}`);
      }
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        if(usuario){
          window.localStorage.setItem(
              `${key}-${usuario.CompaniaId}`,
              JSON.stringify(valueToStore)
          );
        }else{
          window.localStorage.setItem(
              `${key}`,
              JSON.stringify(valueToStore)
          );
        }
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
    }
  };
  return [storedValue, setValue];
};
